import { Injectable } from '@angular/core';
import { CastingTypeFormat } from 'src/app/components/att-casting-view/formats/casting-type-formats-sel/casting-type-formats-sel.component';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { CastingMode, CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';

@Injectable({
	providedIn: 'root'
})
export class NumberZipcodeQualifierService {
	static supportedStats = ['count', 'first', 'last', 'max', 'median', 'min', 'sum'];
	static ToString(value: number, format: CastingTypeFormat): string {
		const stringValue = '' + value;
		switch (format) {
			default:
			case 'zip':
				if (stringValue.length > 5) {
					return stringValue.substr(0, 5);
				}
				return stringValue;
			case 'zip4':
				if (stringValue.length > 5) {
					return stringValue.replace(/(\d{5})(\d{4})/, '$1-$2')
				} else {
					return stringValue;
				}
		}
	}
	static FromString(value: string, format: CastingTypeFormat): number {
		let num: number = null;
		switch (format) {
			default:
			case 'zip':
				num = Number(value);
				break;
			case 'zip4':
				num = Number(value.replace('-', ''));
		}
		if (isNaN(num)) {
			num = null;
		}
		return num;
	}
	public static GetDisplayValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if (!attribute.casting) {
			return val;
		}
		if (!attribute.casting[castingMode]) {
			return val;
		}
		const casting: CastingValue = attribute.casting[castingMode] as CastingValue;
		switch (attribute.type) {
			case 'text':
			case 'string':
				return val;
			default:
				return NumberZipcodeQualifierService.ToString(val, casting.format);
		}
	}
	public static GetTextExportValue(attribute: AttributeInfo, castingMode: CastingMode, val: any): string {
		if ([undefined, null].indexOf(val) > -1) {
			return '';
		}
		return NumberZipcodeQualifierService.GetDisplayValue(attribute, castingMode, val);
	}
	public static GetNativeValue(attribute: AttributeInfo, castingMode: CastingMode, value: any): any {
		return NumberZipcodeQualifierService.FromString(value, attribute.casting[castingMode].format);
	}
	public static SupportsStat(statName): boolean {
		return NumberZipcodeQualifierService.supportedStats.indexOf(statName) > -1;
	}
	constructor() { }
	public static GetNumFormat(attribute: AttributeInfo, castingMode: CastingMode): string {
		const format = attribute.casting[castingMode].format;
		switch (format) {
			case 'zip4':
				return '00000-0000';
			case 'zip':
			default:
				return '00000';
				break;

		}
	}
}
